/* assets/px-careers.js */
(function() {
  const initJobs = () => {
    // 1. Setup Elements
    const grid = document.getElementById('px-jobs-grid');
    if (!grid) return; 
    if (grid.dataset.loaded === 'true') return;
    grid.dataset.loaded = 'true';

    const appContainer = document.getElementById('px-app-container');
    const appTitle = document.getElementById('px-app-title');
    const closeBtn = document.getElementById('px-app-close');
    const frameWrapper = document.getElementById('px-frame-wrapper');
    const loading = document.getElementById('px-loading');
    
    // Filters
    const searchIn = document.getElementById('px-search');
    const deptSel = document.getElementById('px-dept');
    const locSel = document.getElementById('px-loc');
    const loadMoreBtn = document.getElementById('px-load-more');

    const API_URL = "https://api.ashbyhq.com/posting-api/job-board/pergolux";
    let allJobs = [];
    const INITIAL_COUNT = 6;
    let isExpanded = false;

    // Helper: Slug
    function createSlug(job) {
      return `${job.title}-${job.loc}`.toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-');
    }

    // --- FETCH JOBS ---
    fetch(API_URL).then(r=>r.json()).then(data => {
      allJobs = (data.jobs || []).map(j => {
        const jobObj = {
          id: j.id, // This perfectly matches the ashby_jid
          title: j.title,
          dept: j.department || 'General',
          loc: j.location || 'Remote',
          type: j.employmentType || 'Full Time',
          url: j.jobUrl, // STANDARD URL = 100% Reliable
          description: j.descriptionHtml || j.description || "Exciting opportunity at Pergolux.",
          slug: ''
        };
        jobObj.slug = createSlug(jobObj);
        return jobObj;
      });

      const depts = [...new Set(allJobs.map(j=>j.dept))].sort();
      const locs = [...new Set(allJobs.map(j=>j.loc))].sort();
      if(deptSel) depts.forEach(d => deptSel.add(new Option(d, d)));
      if(locSel) locs.forEach(l => locSel.add(new Option(l, l)));

      if(loading) loading.style.display = 'none';
      renderList();
      checkUrlParams();
    }).catch(e => {
      console.error(e);
      if(loading) loading.textContent = "Could not load jobs.";
    });

    // --- RENDER LIST ---
    function renderList() {
      grid.innerHTML = '';
      const term = searchIn ? searchIn.value.toLowerCase() : "";
      const dept = deptSel ? deptSel.value : "";
      const loc = locSel ? locSel.value : "";

      const filtered = allJobs.filter(j => 
        j.title.toLowerCase().includes(term) &&
        (dept === '' || j.dept === dept) &&
        (loc === '' || j.loc === loc)
      );

      if (filtered.length === 0) {
        grid.innerHTML = `<div style="grid-column:1/-1;text-align:center;padding:40px;color:#666;">No jobs found.</div>`;
        if(loadMoreBtn) loadMoreBtn.style.display = 'none';
        return;
      }

      const limit = isExpanded ? filtered.length : INITIAL_COUNT;
      const visible = filtered.slice(0, limit);

      visible.forEach(job => {
        const card = document.createElement('div');
        card.className = 'px-job-card';
        card.innerHTML = `
          <div class="px-job-tag">${job.dept}</div>
          <div class="px-job-title">${job.title}</div>
          <div class="px-job-meta">${job.loc} • ${job.type}</div>
          <div class="px-job-btn">Apply Now &rarr;</div>
        `;
        card.addEventListener('click', () => { 
          updateUrl(job.slug);
          openModal(job);
        });
        grid.appendChild(card);
      });

      if (filtered.length > INITIAL_COUNT) {
        loadMoreBtn.style.display = 'inline-flex';
        loadMoreBtn.textContent = isExpanded ? 'Show Fewer Roles' : 'Show All Roles';
        loadMoreBtn.onclick = () => { isExpanded = !isExpanded; renderList(); };
      } else {
        if(loadMoreBtn) loadMoreBtn.style.display = 'none';
      }
    }

    // --- MODAL LOGIC ---
    function openModal(job) {
      if(!job) return;
      document.body.style.overflow = 'hidden'; 
      if(appTitle) appTitle.textContent = job.title;

      updateSchema(job);

      if (typeof gtag === 'function') {
        gtag('event', 'begin_application', { 
          job_title: job.title,
          job_id: job.id
        });
      }

      frameWrapper.innerHTML = `
        <div class="px-app-loader"><div class="px-spinner"></div><span>Loading application...</span></div>
        <iframe src="${job.url}" class="px-app-frame px-app-job-detail-frame" allow="camera; microphone" onload="this.previousElementSibling.style.display='none';"></iframe>
      `;
      appContainer.style.display = 'block';
    }

    function closeModal() {
      appContainer.style.display = 'none';
      document.body.style.overflow = ''; 
      frameWrapper.innerHTML = '';
      resetUrl();
      removeSchema();
    }

    // --- SEO: JSON-LD SCHEMA ---
    function updateSchema(job) {
      removeSchema(); 
      const script = document.createElement('script');
      script.id = 'px-job-schema';
      script.type = 'application/ld+json';
      script.text = JSON.stringify({
        "@context": "https://schema.org/",
        "@type": "JobPosting",
        "title": job.title,
        "description": job.description,
        "datePosted": new Date().toISOString(),
        "hiringOrganization": { "@type": "Organization", "name": "Pergolux" },
        "jobLocation": { "@type": "Place", "address": { "@type": "PostalAddress", "addressLocality": job.loc } },
        "url": window.location.href 
      });
      document.head.appendChild(script);
    }

    function removeSchema() {
      const existing = document.getElementById('px-job-schema');
      if(existing) existing.remove();
    }

    // --- URL HANDLING ---
    function updateUrl(slug) {
      const url = new URL(window.location);
      url.searchParams.set('job', slug);
      url.searchParams.delete('ashby_jid'); // Converts messy ID links to clean slugs
      history.pushState({ job: slug }, '', url);
    }
    
    function resetUrl() {
      const url = new URL(window.location);
      url.searchParams.delete('job');
      url.searchParams.delete('ashby_jid'); // Cleans up the URL when closing the modal
      history.pushState({}, '', url.pathname + url.search);
    }
    
    function checkUrlParams() {
      const params = new URLSearchParams(window.location.search);
      const slug = params.get('job');
      const ashbyJid = params.get('ashby_jid'); // Check for Ashby's referral ID
      
      let jobToOpen = null;

      if (slug) {
        jobToOpen = allJobs.find(j => j.slug === slug);
      } else if (ashbyJid) {
        // If no slug is present, find the job matching the Ashby UUID
        jobToOpen = allJobs.find(j => j.id === ashbyJid);
      }

      if (jobToOpen) {
        updateUrl(jobToOpen.slug); // Instantly swap the ID in the URL bar for the readable slug
        openModal(jobToOpen);
      }
    }

    // --- ROBUST REDIRECT LOGIC ---
    window.addEventListener("message", function(event) {
      // 1. Log all incoming messages for debugging
      console.log("Message received from iframe:", event.data);

      // 2. Check if the message contains Ashby's success identifiers
      const isAshbySuccess = 
        event.data.type === 'ashby-application-submitted' || 
        event.data.action === 'submission-success' ||
        (typeof event.data === 'string' && event.data.includes('submitted'));

      if (isAshbySuccess) {
        console.log("SUCCESS DETECTED: Redirecting to thank-you page...");
        window.location.href = "/pages/thank-you";
      }
    }, false);

    window.addEventListener('popstate', checkUrlParams);
    
    if(closeBtn) closeBtn.addEventListener('click', () => {
      closeModal();
    });

    const reset = () => { isExpanded = false; renderList(); };
    if(searchIn) searchIn.addEventListener('input', reset);
    if(deptSel) deptSel.addEventListener('change', reset);
    if(locSel) locSel.addEventListener('change', reset);
  }

  document.addEventListener("DOMContentLoaded", initJobs);
  document.addEventListener("shopify:section:load", initJobs);
})();